import type { AxiosError } from 'axios';
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

import { DYDX_LCD_URL } from 'src/constants/transaction';
import type { AccountPayload } from 'src/types/swr/cosmos/account';
import { get, isAxiosError } from 'src/utils/axios';

export function useAccountSWR(cosmosAddress?: string, config?: SWRConfiguration) {
  const requestURL = `${DYDX_LCD_URL}/cosmos/auth/v1beta1/accounts/${cosmosAddress || ''}`;

  const fetcher = async (url: string) => {
    try {
      return await get<AccountPayload>(url);
    } catch (e: unknown) {
      if (isAxiosError(e)) {
        if (e.response?.status === 404) {
          return null;
        }
      }
      throw e;
    }
  };

  const { data, error, mutate } = useSWR<AccountPayload | null, AxiosError>(requestURL, fetcher, {
    dedupingInterval: 14000,
    refreshInterval: 15000,
    errorRetryCount: 0,
    isPaused: () => !cosmosAddress,
    ...config,
  });

  return { data, error, mutate };
}
